import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import { DEFAULT_CSV_COLUMNS } from '../constants/payoutManagerConstants';
import ColumnPicker from './ColumnPicker';

const PayoutDownloadModal = ({ open, onClose, csvPath, csvColumns }) => {
  const [selectedColumns, setSelectedColumns] = useState(DEFAULT_CSV_COLUMNS);
  const [groupByEvent, setGroupByEvent] = useState(false);
  const [includeCash, setIncludeCash] = useState(false);
  const [includeTotals, setIncludeTotals] = useState(false);

  const toggleColumn = (key) => {
    setSelectedColumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    );
  };

  const handleDownload = () => {
    if (selectedColumns.length === 0) return;

    const params = new URLSearchParams();
    selectedColumns.forEach((col) => params.append("columns[]", col));
    params.append("group_by_event", groupByEvent.toString());
    params.append("include_cash", includeCash.toString());
    params.append("include_totals", includeTotals.toString());

    const separator = csvPath.includes("?") ? "&" : "?";
    window.location.href = csvPath + separator + params.toString();
    onClose();
  };

  const canSubmit = selectedColumns.length > 0;

  return (
    <Popup
      modal
      open={open}
      onClose={onClose}
      closeOnDocumentClick
      className="popup-modal"
      contentStyle={{
        textAlign: "left",
        border: "none",
        borderRadius: "8px",
        boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
        width: "520px",
        maxHeight: "80vh",
        padding: "24px",
        overflowY: "auto"
      }}
    >
      {(close) => (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Download Payout Report</h5>
            <a href="#" onClick={(e) => { e.preventDefault(); close(); }}
              className="h4 mb-0 text-muted text-decoration-none">
              &times;
            </a>
          </div>

          <div className="mb-3">
            <label className="d-block mb-2"><strong>Options</strong></label>
            <div className="form-check mb-1">
              <input
                type="checkbox"
                className="form-check-input"
                id="groupByEvent"
                checked={groupByEvent}
                onChange={() => setGroupByEvent(!groupByEvent)}
              />
              <label className="form-check-label" htmlFor="groupByEvent">
                Group by event
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="includeCash"
                checked={includeCash}
                onChange={() => setIncludeCash(!includeCash)}
              />
              <label className="form-check-label" htmlFor="includeCash">
                Include cash transactions
              </label>
            </div>
            <div className="form-check mt-1">
              <input
                type="checkbox"
                className="form-check-input"
                id="includeTotals"
                checked={includeTotals}
                onChange={() => setIncludeTotals(!includeTotals)}
              />
              <label className="form-check-label" htmlFor="includeTotals">
                Include totals row
              </label>
            </div>
          </div>

          <ColumnPicker
            csvColumns={csvColumns}
            selectedColumns={selectedColumns}
            onToggle={toggleColumn}
            onSelectAll={() => setSelectedColumns(csvColumns.map((col) => col.key))}
            onDeselectAll={() => setSelectedColumns([])}
          />

          <div className="d-flex justify-content-end">
            <button className="btn btn-setlist-secondary mr-2" onClick={close}>
              Cancel
            </button>
            <button
              className="btn btn-setlist-primary"
              onClick={handleDownload}
              disabled={!canSubmit}
            >
              Download CSV
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

PayoutDownloadModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  csvPath: PropTypes.string.isRequired,
  csvColumns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
};

export default PayoutDownloadModal;
